import { Link, Outlet } from "@tanstack/react-router";
import { useT } from "@trust/i18n";

/**
 * 登录/注册独立全屏布局(2026-09 结构复刻:对齐旧站 fastj/client login 独立页).
 * 不套门户 PortalHeader:浅灰底全屏居中,顶部 logo + 平台名(点击回首页),下方 Outlet 放表单卡。
 */
export function AuthLayout() {
  const t = useT();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-portal-bg px-6 py-10">
      <Link to="/" className="mb-6 flex items-center no-underline">
        <img src="/portal/logo.png" alt="TRUST" className="h-10" />
        <span className="ml-3 font-bold text-[20px] text-portal-dark">{t("inx.title")}</span>
      </Link>
      <Outlet />
    </div>
  );
}
